import { useGeneratePath, useStaticUrls } from 'platform-components/common';
import { useCallback } from 'react';

type GetLessonRunUrlArg = {
    courseId: number | string;
    clessonId: number | string;
};

export const useGetLessonRunUrl = () => {
    const { classroomCourseLessonRun } = useStaticUrls();
    const generatePath = useGeneratePath();

    return useCallback(
        ({ courseId, clessonId }: GetLessonRunUrlArg) => {
            return generatePath(classroomCourseLessonRun, { courseId, clessonId });
        },
        [classroomCourseLessonRun, generatePath]
    );
};
